var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2866 18.0623C30.2196 18.0623 31.7866 16.4953 31.7866 14.5623C31.7866 12.6293 30.2196 11.0623 28.2866 11.0623C26.3536 11.0623 24.7866 12.6293 24.7866 14.5623C24.7866 16.4953 26.3536 18.0623 28.2866 18.0623Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2866 32.0623C30.2196 32.0623 31.7866 30.4953 31.7866 28.5623C31.7866 26.6293 30.2196 25.0623 28.2866 25.0623C26.3536 25.0623 24.7866 26.6293 24.7866 28.5623C24.7866 30.4953 26.3536 32.0623 28.2866 32.0623Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2866 44.8956C30.2196 44.8956 31.7866 43.3286 31.7866 41.3956C31.7866 39.4626 30.2196 37.8956 28.2866 37.8956C26.3536 37.8956 24.7866 39.4626 24.7866 41.3956C24.7866 43.3286 26.3536 44.8956 28.2866 44.8956Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOne);
export default __webpack_public_path__ + "static/media/more-one.52d8d1d3.svg";
export { ForwardRef as ReactComponent };